import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=759164da&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('759164da')) {
      api.createRecord('759164da', component.options)
    } else {
      api.reload('759164da', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=759164da&", function () {
      api.rerender('759164da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ASY7YVnoZQBa/JS/comp/IncreaseNumber.vue"
export default component.exports